import type { ExploreContentResponsePageAllOfThreeContentItemContentOneOfReferencedTweetTweetAuthorBasicInfo } from './exploreContentResponsePageAllOfThreeContentItemContentOneOfReferencedTweetTweetAuthorBasicInfo';
import type { ExploreContentResponsePageAllOfThreeContentItemContentOneOfReferencedTweetTweetAuthorSocial } from './exploreContentResponsePageAllOfThreeContentItemContentOneOfReferencedTweetTweetAuthorSocial';

/**
 * 트윗 작성자 정보
 */
export type ExploreContentResponsePageAllOfThreeContentItemContentOneOfReferencedTweetTweetAuthor = {
  /** 사용자 기본 정보 */
  basicInfo: ExploreContentResponsePageAllOfThreeContentItemContentOneOfReferencedTweetTweetAuthorBasicInfo;
  /** 소셜 관계 정보 */
  social?: ExploreContentResponsePageAllOfThreeContentItemContentOneOfReferencedTweetTweetAuthorSocial;
};
